import React from 'react';
import { Form } from 'tea-component';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import { IChildProp, ITextGroupProps } from '../../type';
import { getShowLabel } from '../../utils';

export default function TextGroup(props: ITextGroupProps) {
  const { options = [] } = props;
  const { formatMessage } = useIntlExtend();

  return (
    <div className="download-r">
      <div className="download-r-text">
        {options?.map((item: IChildProp, i: number) => (
          <div className="download-r-text-item" key={item.id} style={{ display: item.isShow ? 'flex' : 'none' }}>
            <img src={getDataSourceIcon(item.icon)} alt="" className="download-r-text-img" />
            <Form.Text>
              {getShowLabel(item, formatMessage)}
              {options.length === i + 1 ? '' : ','}
            </Form.Text>
          </div>
        ))}
      </div>
    </div>
  );
}